import { Link } from 'react-router-dom'
import { useAuth } from '../../../auth'
import Paginator from '../../../components/Paginator'
import Sorter, { SortControl } from '../../../components/Sorter'
import StickyTable from '../../../components/StickyTable'
import { useClientiList } from '../../../hooks/clienti'
import { useQsFilters } from '../../../hooks/filters'

const initFilters = (params: URLSearchParams) => ({
  page: Number(params.get('page') ?? 1),
  search: params.get('search') ?? '',
  ordering: params.get('ordering') ?? 'ragione_sociale',
  luogo: params.get('luogo') ?? '',
})

export default function ClientiAreaClienti() {
  const { user } = useAuth()
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)
  const clienti = useClientiList({
    search: filters.search,
    ordering: filters.ordering,
    page: String(filters.page),
    luogo: filters.luogo,
  })

  return (
    <div className="page page-list">
      <div className="row mt-4">
        <div className="col-12 d-flex justify-content-between list-header">
          <h1 className="title">{user?.nome_holding ?? 'Aziende'}</h1>
        </div>
        <div className="col-12">
          <div className="flex-1 d-flex flex-column overflow-hidden">
            <div className="bg-white p-2 border-bottom d-flex justify-content-between align-items-center w-100 rounded list-toolbar">
              <div className="d-flex align-items-center list-filters">
                <div className="ms-2 position-relative">
                  <input
                    type="text"
                    style={{ width: '300px', paddingLeft: '40px' }}
                    className="form-control"
                    placeholder="Cerca azienda..."
                    value={uiFilters.search}
                    onChange={(e) => setFilters({ search: e.target.value, page: 1 })}
                  />
                  <span className="position-absolute material-icons" style={{ left: '10px', top: '8px' }}>
                    search
                  </span>
                </div>
                <div className="ms-2 position-relative">
                  <input
                    type="text"
                    style={{ width: '300px', paddingLeft: '40px' }}
                    className="form-control"
                    placeholder="Cerca luogo..."
                    value={uiFilters.luogo}
                    onChange={(e) => setFilters({ luogo: e.target.value, page: 1 })}
                  />
                  <span className="position-absolute material-icons" style={{ left: '10px', top: '8px' }}>
                    search
                  </span>
                </div>
              </div>
              <div className="me-2 list-count">
                Stai visualizzando {clienti?.data?.count ?? 0} di {clienti?.data?.full_count ?? 0} clienti
              </div>
            </div>
            <StickyTable isLoading={clienti?.isLoading}>
              <thead className="position-sticky top-0 bg-white">
                <Sorter
                  value={uiFilters.ordering}
                  onSortChange={(ordering) =>
                    setFilters({
                      ordering,
                    })
                  }
                >
                  <tr>
                    <th style={{ width: '40%' }}>
                      <div className="d-flex align-items-center">
                        Ragione sociale
                        <SortControl field="ragione_sociale" />
                      </div>
                    </th>

                    <th style={{ width: '20%' }}>
                      <div className="d-flex align-items-center">
                        Indirizzo
                        <SortControl field="sede_principale__via" />
                      </div>
                    </th>
                    <th style={{ width: '20%' }}>
                      <div className="d-flex align-items-center">
                        Sede
                        <SortControl field="sede_principale__comune" />
                      </div>
                    </th>
                    <th style={{ width: '15%' }}>
                      <div className="d-flex align-items-center">
                        Partita iva
                        <SortControl field="sede_principale__partita_iva" />
                      </div>
                    </th>
                    <th style={{ width: '5%' }}>
                      <div className="d-flex align-items-center">
                        Sedi
                        <SortControl field="numero_sedi" />
                      </div>
                    </th>
                  </tr>
                </Sorter>
              </thead>
              <tbody>
                {clienti?.data?.count === 0 && (
                  <tr>
                    <td colSpan={5} className="text-center">
                      Nessun cliente trovato
                    </td>
                  </tr>
                )}
                {clienti?.data?.results?.map((cliente) => (
                  <tr key={cliente.id}>
                    <td>
                      <div className="d-flex align-items-center">
                        <div>
                          <Link className={'link-md'} to={`/clienti/${cliente.id}`}>
                            {cliente.ragione_sociale}
                          </Link>
                          <div className="p-md text-body-secondary">{cliente.sede_principale?.numero_rea}</div>
                        </div>
                      </div>
                    </td>

                    <td>
                      {cliente.sede_principale?.toponimo_data?.nome} {cliente.sede_principale?.via}
                      {', '} {cliente.sede_principale?.civico}
                    </td>
                    <td>
                      <small>{cliente.sede_principale?.nazione}</small>
                      <br />
                      {cliente.sede_principale?.comune_data?.nome} ({cliente.sede_principale?.provincia_data?.sigla})
                    </td>
                    <td>{cliente.sede_principale?.partita_iva ?? ''}</td>
                    <td>{cliente.numero_sedi}</td>
                  </tr>
                ))}
              </tbody>
            </StickyTable>
            <div className="position-relative">
              <Paginator
                count={clienti?.data?.count ?? 0}
                currentPage={uiFilters.page}
                goToPage={(page) => setFilters({ page })}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
